import {
  FontSize,
  FontFamily,
  Components,
  TextTransformOptions,
} from '@powdr/constants';

const fonts = {
  [FontFamily.BASE_FONT]: {
    fontFamily: '"Montserrat Regular"',
    textTransform: TextTransformOptions.NO_TRANSFORM,
    defaultSize: FontSize.REG50,
    scaling: 1,
  },
  [FontFamily.PRIMARY_FONT]: {
    fontFamily: '"Oswald Bold"',
    textTransform: TextTransformOptions.UPPERCASE,
    defaultSize: FontSize.MED30,
    scaling: 1,
  },
  [FontFamily.SECONDARY_FONT]: {
    fontFamily: '"Montserrat Bold"',
    textTransform: TextTransformOptions.UPPERCASE,
    defaultSize: FontSize.REG50,
    scaling: 1,
  },
};

const fontOverrides = {
  [Components.CONTENT_BLOCK_HERO]: {
    header: {
      size: FontSize.LRG40,
    },
    copy: {
      size: FontSize.REG40,
    },
    headerMobile: {
      size: '55px',
    },
  },
};

export const fontTheme = {
  fonts,
  fontOverrides,
  FontSize,
};
